

export function getNumberFromString(size: string): number {
    return Number(size.replaceAll(/[^0-9.]/g, ""));
}

